export default {
    init() {
        this.frUserFormButtonDisable();
        this.frUploadUserImage();
        this.frUserMainInformationForm();
        this.frUserPasswordChangeForm();
        this.frUserDocumentsList();
    },

    frUserDocumentsList(){
        $(".client-docs-current").click(function() {
            $(".client-docs-history-list").addClass('d-none');
            $(".client-docs-current-list").removeClass('d-none');
            $(this).addClass('active');
            $(".client-docs-history").removeClass('active');
        });
        $(".client-docs-history").click(function() {
            $(".client-docs-current-list").addClass('d-none');
            $(".client-docs-history-list").removeClass('d-none');
            $(this).addClass('active');
            $(".client-docs-current").removeClass('active');
        });
    },

    frUserFormButtonDisable(){
        $(".account-edit-form input").keyup(function() {
            $(".account-edit-form button").removeClass('disabled');
        });

        $(".account-password-change-form input").keyup(function() {
            $(".account-password-change-form button").removeClass('disabled');
        });
    },

    frUploadUserImage() {
        let fileTypes = ['jpg', 'png'];
        let frImportFileInput = $('.fr-user-profile .fr-user-icon-file');
        let frImportFileInputParent = $('.account-info--upload-img');
        let errorMsg = frImportFileInputParent.parent().find('.error-message');

        frImportFileInput.on('change', function () {
            if ($(this)[0].files.length > 0) {
                let file = $(this)[0].files[0];
                let isSuccess = true;
                let extension = file.name.split('.').pop().toLowerCase();
                console.log(extension);
                if ( !(fileTypes.indexOf(extension) > -1) ) {
                    isSuccess = false;
                    frImportFileInputParent.addClass('error');
                    errorMsg.show(300);
                }

                if(isSuccess){
                    frImportFileInputParent.removeClass('error');
                    errorMsg.hide();
                    var reader = new FileReader();
                    reader.onload = function(){
                        $('.fr-user-profile .account-info--heading .user-image').css('background', 'transparent url('+reader.result +') center no-repeat');
                        $('.fr-user-profile .account-info--heading .user-image').css('background-size','cover');
                    }
                    reader.readAsDataURL(file);
                }
            }
        });
    },

    frUserMainInformationForm(){
        function validateEmail(elementValue1) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(elementValue1)
        }

        let validateNumbers = function (elementValue2) {
            return /^[-+]?[0-9]+$/.test(elementValue2);
        };

        $(document).on('submit', '.account-edit-form', function (e) {

            e.preventDefault();
            let loader = $('.account-edit-form .loader-holder');
            let errorMsg = $('.account-edit-form .error-message');
            let successMsg = $('.account-edit-form .success-message');
            errorMsg.hide();
            successMsg.hide();
            loader.show();
            let validation = true;
            let inputsEmail = $('.account-edit-form .form-email');
            let inputsPhone = $('.account-edit-form .form-phone');


            $(".form-input.mandatory", this).each(function () {
                let element = $(this);
                if (element.val() === "") {
                    element.closest('.form-item').addClass('input-invalid');
                    validation = false;
                } else {
                    element.closest('.form-item').removeClass('input-invalid');
                }
            });
            if(inputsEmail.length > 0) {
                inputsEmail.each(function(){
                    let value = $(this).val();
                    let valid = validateEmail(value);
                    if (!valid && value.length > 0) {
                        $(this).closest('.form-item').addClass('input-invalid');
                        validation = false;
                    } else {
                        $(this).closest('.form-item').removeClass('input-invalid');
                    }
                });
            }
            if(inputsPhone.length > 0) {
                inputsPhone.each(function(){
                    let value2 = $(this).val();
                    let valid2 = validateNumbers(value2);
                    if (!valid2 && value2.length > 0) {
                        $(this).closest('.form-item').addClass('input-invalid');
                        validation = false;
                    } else {
                        $(this).closest('.form-item').removeClass('input-invalid');
                    }
                });
            }
            if (validation == true) {


                let formData = new FormData( $("#account-edit-form")[0] );
                formData.append('account-edit-form','1');

                $.ajax({
                    type: "POST",
                    enctype: 'multipart/form-data',
                    url: "/user-profile",
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (resp) {
                        successMsg.slideDown(300);
                    }
                });





            } else {
                errorMsg.slideDown(300);
            }

            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    },

    frUserPasswordChangeForm(){
        $(document).on('submit', '.account-password-change-form', function (e) {
            e.preventDefault();
            let loader = $('.account-password-change-form .loader-holder');
            let errorMsg = $('.account-password-change-form .error-message');
            let successMsg = $('.account-password-change-form .success-message');
            let newPassword = $('.account-password-change-form .new-password');
            let newRepeatPassword = $('.account-password-change-form .repeat-new-password');
            errorMsg.hide();
            successMsg.hide();
            loader.show();
            let validation = true;

            $(".form-input", this).each(function () {
                let element = $(this);
                if (element.val() === "") {
                    element.closest('.form-item').addClass('input-invalid');
                    validation = false;
                } else {
                    element.closest('.form-item').removeClass('input-invalid');
                }
            });

            if(newPassword.val() == newRepeatPassword.val()){
                newPassword.closest('.form-item').removeClass('input-invalid');
                newRepeatPassword.closest('.form-item').removeClass('input-invalid');
            } else {
                validation = false;
                newPassword.closest('.form-item').addClass('input-invalid');
                newRepeatPassword.closest('.form-item').addClass('input-invalid');
            }

            if (validation == true) {

                let formData = new FormData( $("#account-password-change-form")[0] );
                formData.append('account-password-change-form','1');

                $.ajax({
                    type: "POST",
                    url: "/user-profile",
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (resp) {
                        successMsg.slideDown(300);
                    }
                });

            } else {
                errorMsg.slideDown(300);
            }

            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    },
}